import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { InvestmentPropertyConst } from './investment-property-const';
import { InvestmentPropertyModel } from './investment-property.model';
import { InvestmentPropertyService } from './investment-property.service';
import { InvestmentPropertyDialogDeleteComponent } from './investment-property-dialog-delete.component';
import { InvestmentPropertyDialogPayComponent } from './investment-property-dialog-pay.component';
import { AccountingManualFormComponent } from '../../accounting/manual/accounting-manual-form.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-investment-property-list',
    templateUrl: './investment-property-list.component.html',
    styleUrls: ['./investment-property.component.css'],
    standalone: false
})
export class InvestmentPropertyListComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = InvestmentPropertyConst.headerTable;

  public dataSource: InvestmentPropertyModel[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;

  public download: boolean = false;

  dataResultTotals = null;

  constructor(
    private investmentPropertyService: InvestmentPropertyService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService
  ) { }

  onSelectedChange(selectedInvestments: InvestmentPropertyModel[]) {
    const toNum = (v: any) => {
      if (v === null || v === undefined || v === '') return 0;
      if (typeof v === 'string') {
        v = v.replace(/\s/g, '').replace(',', '.');
      }
      const n = Number(v);
      return isNaN(n) ? 0 : n;
    };

    let total = 0;
    let totalPaid = 0;

    selectedInvestments.forEach(row => {
      total += toNum(row.total);
      totalPaid += toNum(row.paided);
    });

    const totalUnpaid = total - totalPaid;

    this.dataResultTotals = [
      { alias: 'Total', quantity: total },
      { alias: 'Pagado', quantity: totalPaid },
      { alias: 'Pendiente', quantity: totalUnpaid }
    ];

  }

  //Interacción con la tabla
  onAmountNumberClick(investment) {
    this.pay(investment.uid);
  }

  onDescriptionInvestmentClick(investment) {
    if (investment.image) {
      this.downloadFileImage(investment.uid);
    }

    if (investment.pdf) {
      this.downloadFilePdf(investment.uid);
    }
  }

  onProviderInvestmentClick(investment) {
    this.edit(investment.uid);
  }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
  }

  getList() {
    this.investmentPropertyService.list(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;

        this.calculateTotalsFromData(this.dataSource);

      });
  }

  private calculateTotalsFromData(data: any[]) {
    const toNum = (v: any) => {
      if (v === null || v === undefined || v === '') return 0;
      if (typeof v === 'string') {
        v = v.replace(/\s/g, '').replace(',', '.');
      }
      const n = Number(v);
      return isNaN(n) ? 0 : n;
    };

    let total = 0;
    let totalPaid = 0;

    data.forEach(row => {
      total += toNum(row.total);
      totalPaid += toNum(row.paided);
    });

    const totalUnpaid = total - totalPaid;

    this.dataResultTotals = [
      { alias: 'Total', quantity: total },
      { alias: 'Pagado', quantity: totalPaid },
      { alias: 'Pendiente', quantity: totalUnpaid }
    ];
  }

  pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }
  public pay(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo de inversion y se lo pasamos al modal de pago
    const investmentSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(InvestmentPropertyDialogPayComponent, {
      // height: '60%',
      // width: '70%',
      data: { investment: investmentSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public create() {
    this.router.navigate([this.router.url + '/create']);
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public edit(uid: string): void {
    this.router.navigate([this.router.url + '/edit' + '/' + uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(InvestmentPropertyDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public downloadFileImage(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.investmentPropertyService.downloadFileImage(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Imagen_Adjunta_Inversion", consts.EXT_PNG));
    })
  }

  public downloadFilePdf(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.investmentPropertyService.downloadFilePDF(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName("Pdf_Adjunta_Inversion"));
    })
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public trackByIndex(i: number) { return i; }

}
